import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useRecorderUtils() {
    var _a = React.useState(), recorderElement = _a[0], setRecorderElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || recorderElement)
            return;
        var loadedRecorderElement = client.getRecorderElement();
        setRecorderElement(loadedRecorderElement);
    }, [client, setRecorderElement, recorderElement]);
    return recorderElement;
}
export function useRecorderAddHandler() {
    var recorderElement = useRecorderUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!recorderElement)
            return;
        var subscription = recorderElement.onRecordedData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [recorderElement]);
    return data;
}
/**
* @deprecated Use `recorderUtils.getRecordingData()` method instead
*/
export function useRecordingDataByRecorderId(recorderId) {
    var recorderElement = useRecorderUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!recorderElement)
            return;
        var subscription = recorderElement.getRecordingDataByRecorderId(recorderId).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [recorderElement]);
    return data;
}
